<template>
  <VPopover trigger="hover" placement="bottom">
    <ListButton :img-src="'/icons/check-circle.svg'" :disabled="disabled" @click="onClick()" />
    <template slot="popover">
      <main>{{ tooltip }}</main>
    </template>
  </VPopover>
</template>

<script>
import ListButton from '@/components/shared/lists/ListButton.vue'
import { VPopover } from 'v-tooltip'

export default {
  components: {
    VPopover,
    ListButton,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      required: true,
    }
  },

  methods: {
    onClick() {
      this.$emit('click')
    },
  },
}
</script>
